import {Pipe, PipeTransform} from "@angular/core";


@Pipe({name: 'filtroID', standalone:false})
export class FiltroIDPipe implements PipeTransform {
    transform(objetos: any[], id: number) {
        return id == 0 ? {codigo: ''} : objetos.find(obj => {return obj.id == id});
    }
}
